/**
 * The API serializes every match as N sampled historical points followed by
 * `forecastWindow` daily points. In hybrid mode `origin_window` is the real
 * 65/130/260-session provenance, not an array index, so the chart boundary must
 * be derived from the returned series itself.
 */
export function matchHistoricalPointCount(
  match: Pick<MatchesState, "yaxis">,
  forecastWindow: number,
): number {
  const forecastPoints = Math.max(0, forecastWindow);
  return Math.max(0, match.yaxis.length - forecastPoints);
}

export function matchHistoricalEndIndex(
  match: Pick<MatchesState, "yaxis">,
  forecastWindow: number,
): number {
  return Math.max(0, matchHistoricalPointCount(match, forecastWindow) - 1);
}
